"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _echarts = _interopRequireDefault(require("echarts"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('echarts/theme/macarons'); // echarts theme
var _default = exports.default = {
  name: 'weChatAdBase',
  components: {},
  data: function data() {
    var _this = this;
    return {
      list: [],
      listLoading: true,
      summary: {},
      adType: {
        1: 'Banner广告',
        2: '激励视频广告',
        3: '插屏广告',
        4: '视频广告',
        5: '视频前贴广告',
        6: '封面广告',
        7: '原生模板广告'
      },
      selDate: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var timeOptionRange = _this.timeOptionRange;
          var secondNum = 60 * 60 * 24 * 60 * 1000;
          if (time.getTime() > new Date(new Date().toLocaleDateString()).getTime() - 86400000) {
            return true;
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.getList();
    var endTime = new Date(new Date().toLocaleDateString()).getTime() / 1000 - 86400;
    var startTime = endTime - 6 * 86400;
    this.selDate = [(0, _index.parseTime)(startTime, '{y}-{m}-{d}'), (0, _index.parseTime)(endTime, '{y}-{m}-{d}')];
    this.getStatistics();
  },
  methods: {
    /**
     * 获取广告位置
     */
    getList: function getList() {
      var _this2 = this;
      var url = 'agentapi/ad/get_wx_ad_positions';
      this.$get(url).then(function (res) {
        _this2.list = Object.values(res);
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 设置是否显示
     */
    setShow: function setShow(row) {
      var _this3 = this;
      var is_show = row.is_show == 1 ? 0 : 1;
      this.$post('agentapi/ad/save_wx_ad_positions_permission', {
        business_type: row.business_type,
        is_show: is_show
      }).then(function (res) {
        _this3.$message({
          message: '设置成功',
          type: 'success'
        });
        row.is_show = is_show;
      });
    },
    /**
     * 折线图统计
     */
    getStatistics: function getStatistics() {
      var _this4 = this;
      var url = 'agentapi/analysis/wxad_adpos_general';
      //url = 'agentapi/analysis/wxad_settlement'
      this.$get(url, {
        start_date: this.selDate[0],
        end_date: this.selDate[1]
      }).then(function (res) {
        _this4.summary = res.summary;
        var list = [],
          dayArr = [],
          dayData = {};
        if (res.total_num > 0) {} else {
          var end_time = Date.parse(new Date(_this4.selDate[1])) / 1000,
            start_time = Date.parse(new Date(_this4.selDate[0])) / 1000;
          console.log(start_time);
          console.log(end_time);
          for (var i = start_time; i < end_time; i = i + 86400) {
            dayArr.push((0, _index.parseTime)(i, '{y}-{m}-{d}'));
            dayData[1] = dayData[1] || [];
            dayData[1].push(0);
            dayData[3] = dayData[3] || [];
            dayData[3].push(0);
            dayData[4] = dayData[4] || [];
            dayData[4].push(0);
            dayData[7] = dayData[7] || [];
            dayData[7].push(0);
          }
        }
        _this4.$nextTick(function () {
          _this4.initChart({
            dayArr: dayArr,
            dayData: dayData
          });
        });
      });
    },
    /**
     * 表初始化
     */
    initChart: function initChart(chartData) {
      this.chart = _echarts.default.init(this.$refs.lineChart, 'macarons');
      this.setOptions(chartData);
    },
    /**
     * 图表设置数据
     */
    setOptions: function setOptions() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        dayArr = _ref.dayArr,
        dayData = _ref.dayData;
      if (!dayArr) return;
      this.chart.setOption({
        xAxis: {
          data: dayArr,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        grid: {
          left: 20,
          right: 20,
          bottom: 20,
          top: 40,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          hideDelay: 5000,
          axisPointer: {
            type: 'cross'
          },
          padding: [10, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        // legend: {
        //   data: ['交易额', '订单量', '平均单量', '平均交易额']
        // },
        series: [{
          name: 'Banner广告',
          smooth: true,
          type: 'line',
          data: dayData[1],
          animationDuration: 2800,
          animationEasing: 'cubicInOut'
        }, {
          name: '插屏广告',
          smooth: true,
          type: 'line',
          data: dayData[3],
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: '视频广告',
          smooth: true,
          type: 'line',
          data: dayData[4],
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: '原生模板广告',
          smooth: true,
          type: 'line',
          data: dayData[7],
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }]
      });
    }
  }
};